// composables/useTransitionDirection.ts
export const useTransitionDirection = () => 
{
    return useState<'slide-up' | 'slide-right'| 'slide-down'| 'slide-left'>('transitionDirection', () => 'slide-right');
}